import React from 'react';
import { Navigate } from 'react-router-dom';

import { Paths } from '../../../shared/paths';
import { useAccess } from '../../../hooks/useAccess';
import { NotificationsInnerTabs } from './NotificationsInnerTabs';

export default function Notifications() {
  const { access } = useAccess();
  const canView = access?.notifications?.canView ?? false;

  if (!canView) {
    return <Navigate to={Paths.root} replace />;
  }

  return <NotificationsInnerTabs />;
}
